module.exports = __webpack_public_path__ + "static/jared-forsyth.e7805b03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jared-forsyth.jpg
// module id = 666
// module chunks = 168707334958949